<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
      <el-form-item label="69码或商品名称">
        <el-input v-model="formInline.searchName" placeholder="69码或商品名称"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="success" @click="handleChangePrice()">当前价盘【{{currentPriceMode}}】 点击切换</el-button>
        <el-switch v-model="formInline.showIndex" active-text="只看首页商品" inactive-text="看全部单品和促销"
                   active-value="1" inactive-value="0" @change="getList"></el-switch>
      </el-form-item>
    </el-form>
    <el-table :data="proList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
      <!--  <el-table-column type="selection" width="55"></el-table-column>-->
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column label="状态">
        <template  slot-scope="scope">
          <div v-if="scope.row.PRO_TYPE==1">单品</div>
          <div v-else-if="scope.row.PRO_TYPE==2">促销</div>
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template  slot-scope="scope">
          <img :src="scope.row.PIC_URL" width="60" height="60" class="head_pic"/>
        </template>
      </el-table-column>
      <el-table-column prop="PRO_ID" label="ID"></el-table-column>
      <el-table-column prop="BAR_CODE" label="69码"></el-table-column>
      <el-table-column prop="PRO_NAME" label="产品名称"></el-table-column>
      <el-table-column prop="PRO_PRICE" label="当前价格"></el-table-column>
      <el-table-column prop="PRO_PRICE_A" label="价盘A"></el-table-column>
      <el-table-column prop="PRO_PRICE_B" label="价盘B"></el-table-column>
      <el-table-column prop="PRO_PRICE_C" label="价盘C"></el-table-column>
      <el-table-column prop="PRO_PRICE_S" label="价盘S"></el-table-column>
      <el-table-column label="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-button-group>
            <el-button type="primary" size="mini" @click="handleEditPrice(scope.row)">修改价格</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formInline.currentPage"
          :page-sizes="GCONFIG.pageSizes"
          :page-size="formInline.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="formInline.recordsTotal">
      </el-pagination>
    </div>
    <el-dialog title="切换价盘：只有当前价格、ABCS价盘都不为空的单品/促销，才会切换价格" :visible.sync="showPriceChangeDialog" v-if="showPriceChangeDialog" width="50%">
      <el-form label-width="120px">
        <el-form-item label="选择价盘">
          <template>
          <el-radio-group v-model="modifyPriceMode">
            <el-radio label="A">A</el-radio>
            <el-radio label="B">B</el-radio>
            <el-radio label="C">C</el-radio>
            <el-radio label="S">S</el-radio>
          </el-radio-group>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPriceChangeDialog = false">取 消</el-button>
        <el-button type="primary" @click="changePrice()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改价盘" :visible.sync="showPriceModifyDialog" v-if="showPriceModifyDialog" width="50%">
      <el-form :model="modifyForm" label-width="120px">
        <el-form-item label="id" :hidden="true">
          <el-input v-model=modifyForm.PRO_ID ></el-input>
        </el-form-item>
        <el-form-item label="当前价格" >
          <el-input v-model="modifyForm.PRO_PRICE"  clearable placeholder="当前价格"></el-input>
        </el-form-item>
        <el-form-item label="价格A" >
          <el-input v-model="modifyForm.PRO_PRICE_A"  clearable placeholder="价格A"></el-input>
        </el-form-item>
        <el-form-item label="价格B" >
          <el-input v-model="modifyForm.PRO_PRICE_B"  clearable placeholder="价格B"></el-input>
        </el-form-item>
        <el-form-item label="价格C" >
          <el-input v-model="modifyForm.PRO_PRICE_C"  clearable placeholder="价格C"></el-input>
        </el-form-item>
        <el-form-item label="价格S" >
          <el-input v-model="modifyForm.PRO_PRICE_S"  clearable placeholder="价格S"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group style="margin: 5px 0">
            <el-button @click="showPriceModifyDialog = false"  size="mini">取 消</el-button>
            <el-button type="primary" size="mini" @click="editPrice()">确 定</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//导入 HTTP请求方法
import {getPromotionAndProductPriceList,getCurrentPriceMode,modifyProPrice,changePrice} from '../../api/api'
//定义组件
export default{
  data(){
    return {
      proList:[],
      currentPriceMode:'',
      modifyPriceMode:'',
      showPriceChangeDialog:false,
      showPriceModifyDialog:false,
      loading:true,
      formInline:{
        searchName:"",
        showIndex:1,
        currentPage:parseInt(this.$route.params.id)||1,
        recordsTotal:0,
        pageSize:10,
      },
      modifyForm:{
        PRO_ID:'',
        PRO_TYPE:'',
        PRO_PRICE:'',
        PRO_PRICE_A:'',
        PRO_PRICE_B:'',
        PRO_PRICE_C:'',
        PRO_PRICE_S:''
      }
    }
  },
  components:{
  },
  computed:{
  },
  //挂载时候执行
  mounted(){
    //初始化首页数据
    this.getList();
    this.getCurrentPriceMode();
  },
  methods:{
    //定义查询方法
    getList(){
      this.loading = true;
      getPromotionAndProductPriceList(this.formInline).then((res) => {
        this.loading = false;
        console.log(res);
        if (res.status == 200) {
          this.formInline.recordsTotal = res.data.total;
          this.proList = res.data.list;
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
      })
    },
    getCurrentPriceMode(){
      getCurrentPriceMode().then((res) => {
        this.loading = false;
        if (res.data.status == 200) {
          this.currentPriceMode = res.data.value;
          this.modifyPriceMode = this.currentPriceMode;
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
      })
    },
    handleEditPrice(row){
      this.showPriceModifyDialog = true;
      this.modifyForm.PRO_TYPE = row.PRO_TYPE;
      this.modifyForm.PRO_ID = row.PRO_ID;
      this.modifyForm.PRO_PRICE = row.PRO_PRICE;
      this.modifyForm.PRO_PRICE_A = row.PRO_PRICE_A;
      this.modifyForm.PRO_PRICE_B = row.PRO_PRICE_B;
      this.modifyForm.PRO_PRICE_C = row.PRO_PRICE_C;
      this.modifyForm.PRO_PRICE_S = row.PRO_PRICE_S;
    },
    editPrice(){
      if(this.modifyForm.PRO_PRICE == null || this.modifyForm.PRO_PRICE == ''
          || this.modifyForm.PRO_PRICE_A == null || this.modifyForm.PRO_PRICE_A == ''
          || this.modifyForm.PRO_PRICE_B == null || this.modifyForm.PRO_PRICE_B == ''
          || this.modifyForm.PRO_PRICE_C == null || this.modifyForm.PRO_PRICE_C == ''
          || this.modifyForm.PRO_PRICE_S == null || this.modifyForm.PRO_PRICE_S == ''){
        this.$message({
          showClose: true,
          message: '价格都得填上',
          type: 'error'
        });
        return;
      }
      modifyProPrice(this.modifyForm).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            showClose: true,
            message: '成功',
            type: 'success'
          });
          this.getList();
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
        this.showPriceModifyDialog = false;
      })
    },
    handleChangePrice(){
      this.modifyPriceMode = this.currentPriceMode;
      this.showPriceChangeDialog = true;
    },
    changePrice(){
      changePrice({'priceMode':this.modifyPriceMode}).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            showClose: true,
            message: '成功',
            type: 'success'
          });
          this.getCurrentPriceMode();
          this.getList();
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
        this.showPriceChangeDialog = false;
      })
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formInline.currentPage = val;
      this.getList();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/sales/proPriceList.vue